import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
// must match the list of apps actually being proxied https://github.com/pelotoncycle/chef-repo/blob/9893a57fb6dd7f13273ccb8289fe18a557086472/cookbooks/nginx-router-api/templates/default/nginx-router.conf.erb#L172
// update playground if there's changes https://regexr.com/4l3r8
var VALID_CHARACTERS = "([\\w-]+)";
var PREFIX = "".concat(VALID_CHARACTERS, "--");
var APPS = ['members', 'pos', 'preorder', 'studio', 'uikit', 'upnext', 'www', 'account', 'admin', 'universal-logout'];
var LIT = '--lit';
var SUFFIX = "--".concat(VALID_CHARACTERS);
var SUBDOMAINS = ['secret', 'test', 'uat', 'xtest'];
var CCTLDS = ['com', 'co.uk', 'ca', 'de', 'com.au']; // captures a regex optionally

var optional = function optional(regex) {
  return "(".concat(regex, ")?");
}; // captures one of the elements of a string array


var oneOf = function oneOf(list) {
  return "(".concat(list.join('|'), ")");
};

export var VALID_HOSTNAME = [optional(PREFIX), oneOf(APPS), optional(LIT), optional(SUFFIX), '.', oneOf(SUBDOMAINS), '.onepeloton.', oneOf(CCTLDS)].join('').replace(/\./g, '\\.'); // escape periods

var parseHostname = function parseHostname(hostname) {
  var _ref = hostname.match(VALID_HOSTNAME) || Array(),
      _ref2 = _slicedToArray(_ref, 8),
      app = _ref2[3],
      isLit = _ref2[4],
      api = _ref2[6];

  return {
    app: app,
    isLit: Boolean(isLit),
    api: api
  };
};

export default parseHostname;